<template>
    <div class="mt-3">
        <b-alert show :variant="variant">
            <ul v-if="errorMsg && msg && msg!=''">
                <li v-for="(value, key) in errorMsg" :key="key">
                    <span v-html="value[0]"></span>
                </li>
            </ul>
            <ul v-else>
                <li v-for="(value, key) in errorMsg.errors" :key="key">
                    <span v-html="value"></span>
                </li>
            </ul>
        </b-alert>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    props: {
        msg: String,
        variant: String,
        errorMsg: [Object, Array]
    },
    data() {
        return {
            // Code...
        }
    },
}
</script>